var locale = {
  locale: 'zh-CN',
  // Text Filter
  contain: '包含',
  notContain: '不包含',
  equal: '等于',
  notEqual: '不等于',
  isNull: '为空',
  notIsNull: '不为空',
  // filter button
  resetFilter: '重置',
  confirmFilter: '确定'
};
export default locale;